import React, { useEffect, useState } from "react";
import { Box, Stack, TextField } from "@mui/material";

const EstimationColumns = (getValues, handleSaveCell) => [
  {
    accessorKey: "UID",
    header: "UID",
    size: 120,
    enableEditing: false,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: {
      sx: {
        textAlign: "center",
        borderRight: "none",
      },
    },
  },
  {
    accessorKey: "Description",
    header: "Description",
    size: 260,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
    Footer: () => (
      <Stack>
        <Box
          color="warning.main"
          sx={{ textAlign: "center", fontSize: "18px", fontWeight: "bold" }}
        >
          Total
        </Box>
      </Stack>
    ),
  },
  {
    accessorKey: "Qty",
    header: "Req. Qty",
    size: 70,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
  },
  {
    accessorKey: "Procured Qty",
    header: "Procured Qty",
    size: 90,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
     enableEditing: false,
     Cell: ({ cell, row }) => {
       const [localValue, setLocalValue] = useState(
         row.original["Procured Qty"] ?? ""
       );

       useEffect(() => {
         setLocalValue(row.original["Procured Qty"] ?? "");
       }, [row.original["Procured Qty"]]);

       return (
         <TextField
           type="text"
           size="small"
           variant="standard"
           value={localValue}
           onChange={(e) => setLocalValue(e.target.value)}
           onBlur={() =>
             handleSaveCell(
               { row, column: cell.column },
               localValue === "" ? "" : localValue
             )
           }
           fullWidth
         />
       );
     },
  },
  {
    accessorKey: "Measure/Wt",
    header: "Total WT",
    size: 90,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
  },
  {
    accessorKey: "Material Cost/ Unit",
    header: "Unit Cost",
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
  },
  {
    accessorKey: "Material Cost",
    header: "Total Cost",
    size: 100,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
    Footer: () => (
      <Stack>
        <Box color="warning.main" sx={{ textAlign: "center" }}>
          {getValues("totalMaterialCost") || 0}
        </Box>
      </Stack>
    ),
  },
  {
    accessorKey: "FAB Hours",
    header: "Total Manhours",
    size: 100,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
    Footer: () => (
      <Stack>
        <Box color="warning.main" sx={{ textAlign: "center" }}>
          {getValues("totalHours") || 0}
        </Box>
      </Stack>
    ),
  },
];

export default EstimationColumns;
